<div class="container">
  <ul
    ngbNav
    #nav="ngbNav"
    class="nav-tabs border-0"
    data-automation-id="tab-navigation"
    (shown)="onTabChange($event)"
  >
    <li [ngbNavItem]="1">
      <a
        role="button"
        ngbNavLink
        class="text-black"
        data-automation-id="list-view-link"
        >List View</a
      >
      <ng-template ngbNavContent>
        <ng-template *ngTemplateOutlet="listDetails"></ng-template>
        <digital-platform-facility-results
          [facilities]="filteredFacilities"
          [serviceBadgesHeight]="serviceBadgesHeight"
        ></digital-platform-facility-results>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a
        role="button"
        ngbNavLink
        class="text-black"
        data-automation-id="map-view-link"
        >Map View</a
      >
      <ng-template ngbNavContent>
        <ng-template *ngTemplateOutlet="listDetails"></ng-template>
        <div class="facilities-map-container">
          <digital-platform-bing-map
            [pushpins]="facilities"
            [stateKey]="stateKey"
            [filteredPushpins]="filteredFacilities"
            [initLat]="latitude"
            [initLng]="longitude"
            [zoom]="zoom"
            (updateFilter)="handleUpdateMap($event)"
            (updateZoom)="handleUpdateZoom($event)"
            (updateCoordinates)="handleUpdateCoordinates($event)"
          ></digital-platform-bing-map>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>

<ng-template #listDetails>
  <div class="d-flex justify-content-between">
    <small class="d-block mb-4">
      {{ filteredFacilities?.length }} results
    </small>
    <digital-platform-facility-filter-service
      [availableServices]="availableServices"
      [selectedServices]="selectedServices"
      (updateSelectedServices)="handleUpdateServices($event)"
      #facilityFilterService
    ></digital-platform-facility-filter-service>
  </div>
</ng-template>
